// extracted by mini-css-extract-plugin
export default {"avarie__container":"style_avarie__container__JEKeK","avarie__container__icon":"style_avarie__container__icon__9DLfR"};